// @flow

import type {TreeStructure} from '../typedef';

export const filterTreeByIds = (data: TreeStructure, ids: Array<string>): TreeStructure => {
    return data.filter(item => {
        if (item.children) {
            const children = filterTreeByIds(item.children, ids);

            if (children.length) {
                item.children = children;
            } else {
                delete item.children;
            }
        }

        return ids.includes(item.id);
    });
};
